import React from 'react';

import * as Analytics from 'analytics/Analytics';
import {makeAnalyticsEventId} from 'analytics/Analytics';
import {CREATE_PROCESS_MODAL_TYPE} from 'constants/analytics-products/WorkflowAnalyticsConstants';
import {ActionOrigin, ANALYTICS_MODULE, COMMON_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {getInitialCreateTaskModalViewPreference} from 'processes/modals/CreateProcessModalViewPreference';
import {Schema} from 'schemas/SchemaConstants';
import legacyRunModal from 'ui-library/legacyRunModal';

import CreateProcessModal, {TableOrFormRenderOptionsToAnalyticsType} from '../modals/CreateProcessModal';
import CreateFromSchemaButton from './CreateFromSchemaButton';

interface NewProcessDropdownProps {
  processTaskSchemas: Array<Schema> | null;
  isExpanded?: boolean;
}

export default function NewProcessDropdown(props: NewProcessDropdownProps): JSX.Element {
  return (
    <CreateFromSchemaButton
      schemas={props.processTaskSchemas}
      filterByObjectsCreatable={true}
      onSelect={(schema) => {
        const analyticsEventGroupId = makeAnalyticsEventId();
        Analytics.trackEventWithModule(COMMON_ANALYTICS_ACTIONS.OPENED_MODAL, ANALYTICS_MODULE.WORKFLOWS, {
          event_group_id: analyticsEventGroupId,
          action_origin: ActionOrigin.WORKFLOWS_SIDEPANEL_CREATE,
          default_task_creation_view:
            TableOrFormRenderOptionsToAnalyticsType[getInitialCreateTaskModalViewPreference(schema.id)[0]],
          modal_type: CREATE_PROCESS_MODAL_TYPE,
        });
        legacyRunModal(CreateProcessModal, {
          processTaskSchemaId: schema.id,
          processTaskSchemaName: schema.name,
          initialFolderId: null,
          taskGroupInstructions: null,
          sourceType: 'dashboard',
          analyticsEventGroupId,
        });
      }}
      isExpanded={props.isExpanded}
    />
  );
}
